import { useTranslations } from 'next-intl'
import type { NextPage, GetServerSidePropsContext } from 'next'
import { useQuery } from '@apollo/client'
import { useRouter } from 'next/router'

// import { addApolloState, initializeApollo } from '@/utils/apolloClient'
import { getFacilityById } from '@/api/facilities'
import { SITE_URL } from '@/constants'
import { IFacilityNode } from '@/types/facilities.interface'
import { FacilityInformation } from '@/features/facilities/FacilityInformation'
import { getAllMinerProductsByFacilityId } from '@/api/minersListing'
import SeoHead from '@/components/seo-head'
import { Loading } from '@/components/Loading'

const FacilityPage: NextPage = () => {
  const t = useTranslations()
  const router = useRouter()
  const { query } = router
  const { data } = useQuery(getFacilityById, {
    variables: {
      facilitiesId: query.id,
    },
    fetchPolicy: 'cache-first',
  })

  const { data: products, loading } = useQuery(
    getAllMinerProductsByFacilityId,
    {
      variables: {
        facilityId: query.id,
      },
      fetchPolicy: 'cache-first',
    }
  )

  if (loading) {
    return <Loading />
  }

  const facility: IFacilityNode = data?.allFacilities?.nodes[0]
  if (facility && !router.isFallback) {
    const facilityName =
      facility?.facilitiesName || t('facilities-list.facility')
    return (
      <>
        <SeoHead
          title={t('facilities-list.seo.detail-title', {
            facility: facilityName,
          })}
          breadcrumbs={[
            {
              position: 2,
              item: `${SITE_URL}/facilities`,
              name: t('facilities-list.seo.breadcrumb'),
            },
            {
              position: 3,
              item: `${SITE_URL}${router.asPath}`,
              name: facilityName,
            },
          ]}
          description={t('facilities-list.seo.detail-description', {
            facility: facilityName,
          })}
        />
        <FacilityInformation facility={facility} products={products} />
      </>
    )
  }

  return <></>
}

export async function getServerSideProps({
  locale,
}: // params,
GetServerSidePropsContext) {
  // const id = params?.id

  // const apolloClient = initializeApollo()
  // const { data } = await apolloClient.query({
  //   query: getFacilityById,
  //   variables: {
  //     facilitiesId: id,
  //   },
  // })

  // if (!data) {
  //   return addApolloState(apolloClient, {
  //     notFound: true,
  //   })
  // }

  // return addApolloState(apolloClient, {
  return {
    props: {
      messages: (await import(`../../../locales/${locale}.json`)).default,
    },
  }
  // })
}

export default FacilityPage
